export default class AdminMedicalDiagnosisCodes {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminICD10MedicalDiagnosisCodesEndpoint, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminICD10MedicalDiagnosisCodesEndpoint}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminICD10MedicalDiagnosisCodesEndpoint}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminICD10MedicalDiagnosisCodesEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminICD10MedicalDiagnosisCodesEndpoint}/${id}`, payload, {})
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminICD10MedicalDiagnosisCodesEndpoint}/${id}`, {})
  }
}
